import moment from 'moment-timezone';
import { useMemo } from 'react';

import { AutocompleteSingle } from '../Autocomplete';

export const TimezoneSelector = ({
  value,
  onChange,
  ...otherProps
}: {
  value: string;
  onChange: (nextValue: string) => void;
  fullWidth?: boolean;
  disabledClearable?: boolean;
}) => {
  const options = useMemo(
    () =>
      moment.tz.names().map((name) => ({
        name
      })),
    []
  );

  const selected = options.find((o) => o.name === value) || null;

  return (
    <AutocompleteSingle
      value={selected}
      options={options}
      getOptionLabel={(o) => o.name}
      getOptionSelected={(o, v) => o.name === v?.name}
      onChange={(o) => o && onChange(o.name)}
      {...otherProps}
    />
  );
};
